import { useKnockFeed } from '@knocklabs/react-notification-feed'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'
import { Text } from 'lib/Text'
import { NotificationRowLoading, NotificationRow, NotificationRowWelcome, Row } from './NotificationRow'

const Feed = styled.div`
  margin: 24px 12px 24px 16px;
`

const Header = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const AnimatedRow = styled(motion.div)`
  &:last-of-type {
    ${Row} {
      border: 0;
    }
  }
`

const NotificationsContainer = styled.div``

interface Props {
  onClickItem?: () => void
}

export const NotificationsList = ({ onClickItem }: Props) => {
  const { useFeedStore } = useKnockFeed()
  const items = useFeedStore((state) => state.items)
  const loading = useFeedStore((state) => state.loading)

  return (
    <Feed>
      <Header>
        <Text weight="bold" size="s">
          Notifications
        </Text>
      </Header>
      <NotificationsContainer>
        <AnimatePresence>
          {loading && !items.length && <NotificationRowLoading />}
          {items.map((item, ix) => (
            <AnimatedRow
              key={item.id}
              initial={{ opacity: 0.2 }}
              animate={{ opacity: 1 }}
              transition={{ opacity: { delay: ix * 0.035 } }}
              exit={{ opacity: 0 }}>
              <NotificationRow onClickItem={onClickItem} item={item} />
            </AnimatedRow>
          ))}
          {!loading && !items.length && <NotificationRowWelcome />}
        </AnimatePresence>
      </NotificationsContainer>
    </Feed>
  )
}
